import { CustomRoute } from "src/app/pages/custom-route/interfaces/custom-route.interface";
import { EditedCustomRoute } from "../interfaces/edit-route.interface";

export const editedCustomRouteAdapter = (customRouteData: CustomRoute): EditedCustomRoute => ({
  id: customRouteData.id,
  dailyRoutes: customRouteData.dailyRoutes.map(dailyRoute => ({
    id: dailyRoute.id,
    date: dailyRoute.date,
    weatherIconName: dailyRoute.weatherIconName,
    startPoint: dailyRoute.startPoint,
    endPoint: dailyRoute.endPoint,
    points: dailyRoute.points.map(point => ({
      id: point.id,
      type: point.type,
      img: point.img,
      title: point.title,
      startDate: point.startDate,
      endDate: point.endDate,
      duration: point.duration,
      previousLocation: point.previousLocation,
      currentLocation: point.currentLocation,
      nextPoint: point.nextPoint,
      transferPathDistances: point.transferPathDistances,
    }))
  }))
});
